import { Dispatch, SetStateAction, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVertFilledIcon } from '../../../../assets/icons/icons';
import { download, formatData } from '../../../../utils/csvHelpers';
import Utils from '../../../../utils/utils';
import { EventService, OperationSummary, OperationActivity  } from '@networkRequest';
import { useUser } from '@hooks/useUser';

const ActivitiesMenu = ({
  loading = false,
  activities,
  operation,
  onError = () => {},
}: {
  loading?: boolean;
  activities: OperationActivity[];
  operation: OperationSummary | null;
  onError?: Dispatch<SetStateAction<string>>
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const { user } = useUser();

  const handleDownloadCsv = () => {
    setMenuAnchorEl(null);

    if (!user || !operation) {
      onError('Operation not found');
      return;
    }
    
    if (activities.length == 0) {
      onError('No activity to download');
      return;
    }

    const cleanedData = activities.map((activity) => ({
        description: activity.description,
        incident_id: activity.incident_id,
        performed_at: activity.performed_at,
        // convert author to author name
        author: Utils.fullName(activity.author.agency_official.first_name, activity.author.agency_official.last_name),
        // convert officials to string of full names
        officials: activity.officials.map((official) => Utils.fullName(official.agency_official.first_name, official.agency_official.last_name)).join(', ')
    }));
    const formattedData = formatData(cleanedData);
    const currentDateTime = new Date().toISOString();

    download(
      formattedData,
      `${operation?.title}_${currentDateTime}`
    );

    EventService.recordOperationActivityCsvDownload(user.accessToken, operation.id);
  };
  return (
    <menu>
      <IconButton
        onClick={(e) => setMenuAnchorEl(e.currentTarget)}
        aria-label="More options"
        sx={{
          width: 24,
          height: 24,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <MoreVertFilledIcon />
      </IconButton>
      <Menu
        disablePortal
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleDownloadCsv} disabled={loading}>
          Download Activity CSV
        </MenuItem>
      </Menu>
    </menu>
  );
};

export default ActivitiesMenu;